import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MainpageComponent } from './mainpage/mainpage.component';
import { BasicComponent } from './basic/basic.component';
import { IntermediateComponent } from './intermediate/intermediate.component';
import { PremiumComponent } from './premium/premium.component';
import { SupplementComponent } from './supplement/supplement.component';


const routes: Routes = [
  {path:'main', component:MainpageComponent},
    {path:'basic', component:BasicComponent},
    {path:'intermediate', component:IntermediateComponent},
    {path:'premium', component:PremiumComponent},
    {path: 'supplement', component:SupplementComponent},
    {path:'',redirectTo:'/main',pathMatch:'full'},
    {path:'**',component:MainpageComponent},
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
